import { apiUrl } from './helper';

const urlBase64ToUint8Array = (base64String) => {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const raw = window.atob(base64);
    const output = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; i += 1) {
        output[i] = raw.charCodeAt(i);
    }
    return output;
};

export const pushSupported = () => (
    typeof window !== 'undefined'
    && 'serviceWorker' in navigator
    && 'PushManager' in window
    && 'Notification' in window
);

export const registerAdminServiceWorker = async () => {
    if (!('serviceWorker' in navigator)) return null;
    const reg = await navigator.serviceWorker.register('/sw.js', { scope: '/' });
    await navigator.serviceWorker.ready;
    return reg;
};

export const getPushPermission = () => (
    pushSupported() ? Notification.permission : 'unsupported'
);

export const enableAdminPush = async (token) => {
    if (!pushSupported()) {
        throw new Error('Notifications non supportées sur cet appareil');
    }
    if (!token) {
        throw new Error('Session admin requise');
    }

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
        throw new Error('Permission refusée');
    }

    const reg = await registerAdminServiceWorker();
    const keyRes = await fetch(`${apiUrl}/api/admin/push/vapid-public-key`, {
        headers: { 'x-admin-token': token },
    });
    const keyData = await keyRes.json();
    if (!keyRes.ok || !keyData.publicKey) {
        throw new Error(keyData.message || 'Clé VAPID indisponible');
    }

    let subscription = await reg.pushManager.getSubscription();
    if (!subscription) {
        subscription = await reg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(keyData.publicKey),
        });
    }

    const saveRes = await fetch(`${apiUrl}/api/admin/push/subscribe`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-admin-token': token,
        },
        body: JSON.stringify({
            subscription,
            label: 'admin-phone',
        }),
    });
    const saveData = await saveRes.json();
    if (!saveRes.ok) {
        throw new Error(saveData.message || 'Enregistrement impossible');
    }

    localStorage.setItem('adminPushEnabled', '1');
    return { subscription, stockThreshold: keyData.stockThreshold };
};

export const disableAdminPush = async (token) => {
    if (!pushSupported()) return;
    const reg = await navigator.serviceWorker.getRegistration();
    const subscription = await reg?.pushManager?.getSubscription();
    if (subscription) {
        if (token) {
            await fetch(`${apiUrl}/api/admin/push/unsubscribe`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-admin-token': token,
                },
                body: JSON.stringify({ endpoint: subscription.endpoint }),
            }).catch(() => {});
        }
        await subscription.unsubscribe().catch(() => {});
    }
    localStorage.removeItem('adminPushEnabled');
};

export const sendTestPush = async (token) => {
    const res = await fetch(`${apiUrl}/api/admin/push/test`, {
        method: 'POST',
        headers: { 'x-admin-token': token },
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || 'Test échoué');
    return data;
};
